import React, { FC } from 'react';
import { RadioButton, RadioButtonType } from '@components/atoms/RadioButton';

interface RadioFilterProps {
    options: { id: string; label: string; value: string; checked?: boolean; onClick: () => void }[];
}

export const RadioFilter: FC<RadioFilterProps> = ({ options }) => {
    return (
        <div className="pt-2">
            {options.map((option, index) => (
                <RadioButton
                    key={`option-${index}`}
                    type={RadioButtonType.normal}
                    size="sm"
                    classes="my-1"
                    id={option.id}
                    name={option.id}
                    value={option.value}
                    label={option.label}
                    checked={option.checked}
                    onClick={option.onClick}
                />
            ))}
        </div>
    );
};
